import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AcceptEnum } from '@commons/file-picker/models/accept.enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-ui-file-picker-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrls: ['./placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceholderComponent implements OnChanges {
  @Input() id!: string;
  @Input() accept!: AcceptEnum[];
  @Input() maxSize!: number;
  @Input() caption?: string;
  @Output() choose = new EventEmitter<File>();
  computedAccept!: string;
  maxSizeExcedded = false;
  dragover$ = new BehaviorSubject(false);

  @HostListener('drop', ['$event'])
  doDrop(event: any): void {
    if (this.accept && !this.accept.includes(event.dataTransfer.files[0].type as AcceptEnum)) {
      event.preventDefault();
    }
  }

  @HostListener('dragenter', ['$event'])
  onDragOver(event: any): void {
    event.stopPropagation();
    event.preventDefault();
    this.dragover$.next(true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(_: any): void {
    this.dragover$.next(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['accept']) {
      this.computedAccept = changes['accept'].currentValue ? changes['accept'].currentValue.join(', ') : undefined;
    }
  }

  onFileInput(event: Event): void {
    const files = (event?.target as any)['files'];
    if (!!files && files[0]?.size / 1024 / 1024 <= this.maxSize) {
      this.maxSizeExcedded = false;
      this.choose.emit(files[0]);
    } else {
      this.maxSizeExcedded = true;
    }
  }
}
